import styled, { css } from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const BonusesButton = styled(Button)`
    ${({ disabled }) => !disabled && css`
        color: ${COLORS.TextWhite};
        background-color: none;
        background: radial-gradient(63.45% 90.07% at 28.3% 105.36%, #ED3D3D 0%, rgba(237, 61, 61, 0) 100%),
                    linear-gradient(105.23deg, #B9CF31 15.62%, #FA00FF 106.65%);

        &:hover {
            background-color: none;
            background: radial-gradient(63.45% 90.07% at 28.3% 105.36%, #ED3D3D 0%, rgba(237, 61, 61, 0) 100%),
                        linear-gradient(105.23deg, #B9CF31 15.62%, #FA00FF 106.65%);
            opacity: .7;
        }
    `};
`;

interface IProps {
    btnText: string,
    isDisable: boolean,
    onClick: () => void,
}

/**
 * Кнопка оплаты бонусами
 */
export const BonusesPayButton = ({ btnText, onClick, isDisable }: IProps) => {
    return (
        <BonusesButton
            disabled={isDisable}
            onClick={onClick}
        >
            {btnText}
        </BonusesButton>
    );
};
